var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_232",
    "data-name": "Group 232",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.09,
    height: 122.09,
    viewBox: "0 0 122.09 122.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 61.045,
    cy: 61.045,
    rx: 61.045,
    ry: 61.045,
    transform: "translate(0)",
    fill: "#595a5c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M256.819,230.57h-59.2a3.7,3.7,0,0,0-3.7,3.7v40.7a3.7,3.7,0,0,0,3.7,3.7h59.2a3.7,3.7,0,0,0,3.7-3.7v-40.7A3.7,3.7,0,0,0,256.819,230.57ZM228.2,254.448l-31.233-13.607,2.129-4.946,28.995,12.82L254.91,236.34l2.287,4.483Z",
    transform: "translate(-166.804 -193.573)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a4d60e6c99dec0d26bb1aeb9d0b99d09.svg";
export { ForwardRef as ReactComponent };